module.exports = __webpack_public_path__ + "static/customer-journey-416655c2626c507de7e0db359650b567.png";